import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { PullRefresh, Loading } from 'vant'


export default /*@__PURE__*/_defineComponent({
  __name: 'PullToRefresh',
  props: {
  minHeight: {
    // 下拉区域始终为全屏的高度
    type: String,
    default: 'calc(100vh)'
  },
  refreshing: {
    type: Boolean,
    default: false
  }
},
  emits: ['onRefresh', 'update:refreshing'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

const refresh = computed({
  get: () => props.refreshing,
  set: (val) => {
    emits('update:refreshing', val)
  }
})

const onRefresh = () => {
  emits('onRefresh')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PullRefresh), {
    modelValue: refresh.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refresh).value = $event)),
    onRefresh: onRefresh,
    style: _normalizeStyle({ 'min-height': __props.minHeight })
  }, {
    pulling: _withCtx(() => [
      _createVNode(_unref(Loading), { type: "spinner" })
    ]),
    loosing: _withCtx(() => [
      _createVNode(_unref(Loading), { type: "spinner" })
    ]),
    loading: _withCtx(() => [
      _createVNode(_unref(Loading), { type: "spinner" })
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["modelValue", "style"]))
}
}

})